import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center my-5" }
const _hoisted_2 = { class: "d-flex justify-center my-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar, {
          color: "primary",
          flat: "",
          app: "",
          dark: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_spacer)
          ]),
          _: 1
        }),
        _createVNode(_component_v_container, { fluid: "" }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex justify-center my-5" }, [
              _createElementVNode("p", null, " 所属している園が見つかりません。管理画面より保育士アカウントの登録を行ってください。 ")
            ], -1)),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_btn, {
                onClick: _ctx.toTop,
                color: "primary",
                block: "",
                loading: _ctx.btnLoading
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" topページへ ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "loading"])
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_btn, {
                onClick: _ctx.logout,
                color: "primary",
                block: "",
                outlined: ""
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" ログアウト ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}